import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import ElectronicExaminationSearchVLModalContent, {
	ElectronicExaminationSearchVLValues,
} from './ElectronicExaminationSearchVLModalContent';

interface Props {
	opened: boolean;
	onClose: () => void;
	onSubmit: (values: ElectronicExaminationSearchVLValues) => void;
}

const ElectronicExaminationSearchVLModal: React.FC<Props> = props => {
	const { opened, onClose, onSubmit } = props;

	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose()}
			fullScreen={false}
			size={Size.LG}
			wrapChat={isCase}>
			<Modal.Header title='nczi.examination.vl.search.title' firstUpper />
			<Modal.Content>
				<ElectronicExaminationSearchVLModalContent
					onClose={onClose}
					onSubmit={onSubmit}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicExaminationSearchVLModal;
